import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import ActivityService from '../services/ActivityService';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';

class ActivityEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ActivityService());
        this.state = {
            elementId: props.elementId,
            element: {
                name: '',          
                status: { enumValue: 'ACTIVE', label: 'Aktywny' },
                useForExtraWorks: false,
                useForTimeReporting: false,
            },
            viewMode: this.props.viewMode,
        };
        this.submitForm = this.submitForm.bind(this);
        this.validator.addCustomRule('min_one_checkbox_required', 'Wymagane zaznaczenie co najmniej jednej opcji Używaj dla', (value, params) => {
            const fst = this.state.element.useForExtraWorks;
            const snd = this.state.element.useForTimeReporting;
            return (fst === true || snd === true)  ;
        },
            (message, params) => message,
        );
        if (this.state.element.useForExtraWorks === false && this.state.element.useForTimeReporting === false) {
            this.validator.setFieldValid('useForExtraWorks', false)
            this.validator.setFieldValid('useForTimeReporting', false)
        }
    }
    translate(key) {
        const { t } = this.props;
        return t(key);
    }
    prepareFooter() {
        const { t } = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    id={'cancel-activity-dialog-btn'}
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    id={"save-activity-dialog-btn"}
                    label={this.state.viewMode === 'NEW' ? t('activity.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.submitForm}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    submitForm(){
        const {element} = this.state;
        this.updateValidatedFields(element.useForExtraWorks, element.useForTimeReporting);
        this.handleFormSubmit();
    }

    updateValidatedFields(extraWorksActivity, timeReportingActivity){
        if(extraWorksActivity === true || timeReportingActivity === true){
            this.validator.setFieldValid('useForExtraWorks', true);
            this.validator.setFieldValid('useForTimeReporting', true);   
        }
    }

    renderHeader() {
        const { t } = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('activity.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                                ? `${t('activity.editHeader')}`
                                : this.state.viewMode === 'DELETE'
                                    ? `${t('activity.deleteHeader')}`
                                    : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    

    getAddSucces() {
        const { t } = this.props;
        return t('activity.addSuccess');
    }

    getUpdateSucces() {
        const { t } = this.props;
        return t('activity.updateSuccess');
    }
    createOrUpdate() {
        const { element } = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            }
        }
    }


    renderDetails() {
        const { t } = this.props;

        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='name'
                        name='name'
                        label={'Nazwa'}
                        colClass='col-md-12'
                        value={this.state.element.name}
                        validator={this.validator}
                        validators='required|max:255'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                    /> </DivContainer>
                <DivContainer colClass='row' rendered={this.props.activityUseVisible}><label id={`useFor-label-id`} className='p-label' style={{ width: '50%', marginTop: '10px' }}>Używaj dla</label></DivContainer>
                <DivContainer colClass='row' rendered={this.props.activityUseVisible}>
                    <InputCheckboxComponent
                        id={`useForExtraWorks`}
                        key={`useForExtraWorks`}
                        name='useForExtraWorks'
                        label={"Prac dodatkowych"}
                        colClass='col-md-6 col-sm-12'
                        value={this.state.element.useForExtraWorks}
                        viewMode={this.props.viewMode}
                        labelOnRight
                        onChange={this.handleChange}
                    />
                    <InputCheckboxComponent
                        id={`useForTimeReporting`}
                        key={`useForTimeReporting`}
                        name='useForTimeReporting'
                        label={"Raportowania czasu"}
                        colClass='col-md-6 col-sm-12'
                        value={this.state.element.useForTimeReporting}
                        viewMode={this.props.viewMode}
                        labelOnRight
                        onChange={this.handleChange}
                    />
                </DivContainer>
                <div aria-live='assertive' className='login-form-validation'>
                    {this.validator.message(undefined, undefined, this.state.element.useForTimeReporting, 'min_one_checkbox_required')}
                </div>
                
            </React.Fragment>
        );
    }
}

ActivityEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
    activityUseVisible: false,
};

ActivityEditDialog.propTypes = {
    activityUseVisible: PropTypes.bool,
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roleTypes: PropTypes.object,
    className: PropTypes.string
};

export default withTranslation()(ActivityEditDialog);
